import React from "react";

export default function KpiCard({ label, value, sub, accent, testid }) {
  return (
    <div
      data-testid={testid}
      className="bg-white border border-zinc-200 p-5 flex flex-col justify-between min-h-[110px]"
    >
      <div className="data-label">{label}</div>
      <div className="mt-3">
        <div className={`metric-value text-3xl ${accent || "text-zinc-900"}`}>{value}</div>
        {sub && <div className="text-xs text-zinc-500 mt-1 font-mono">{sub}</div>}
      </div>
    </div>
  );
}
